<template>
  <div class="at-least-one-positive">
    <lottie-player v-if="animate" class="image" :src="JSON.stringify(require('@/assets/celebration/onepositive.json'))"
                   :autoplay="true" :loop="true"/>
    <img v-else class="image" :src="require('@/assets/celebration/onepositive.svg')">
    <div class="well-done">
      <span>חודש חדש, הזדמנות חדשה</span>
    </div>
    <div class="celebration-subtitle">
      <span>{{ thisMonth }}</span>
      <span>נגמר שלילי, יש חודשים כאלה. חשוב לזכור שהיו גם חודשים חיוביים בחצי שנה האחרונה. קדימה</span>
      <span>ל{{ nextMonth }}!</span>
    </div>
  </div>
</template>

<script>

import '@lottiefiles/lottie-player';
import cashflowHistory from '@/store/utilities/cashflow-history';

export default {
  name: 'AtLeastOnePositiveCore',
  props: {
    cashflowDate: {
      type: String,
      required: true,
    },
    animate: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    nextMonth() {
      return cashflowHistory.getFullMonthName(cashflowHistory.getNextBudgetDate(this.cashflowDate));
    },
    thisMonth() {
      return cashflowHistory.getFullMonthName(this.cashflowDate);
    },
  },
};

</script>

<style lang="scss">
@import '~base-ui/src/scss/riseup-colors';

.at-least-one-positive {
  text-align: center;
  font-family: SimplerProBold;
  font-size: 22px;
  line-height: 24px;

  .image {
    height: 100px;
  }

  .well-done {
    margin-top: 35px;
    font-size: 24px;
    line-height: 20px;
    margin-bottom: 20px;
  }

  .celebration-subtitle {
    font-family: SimplerPro;
    text-align: center;
    font-size: 18px;
    line-height: 25px;
  }
}

</style>
